import { BreadcrumbItem } from "../components/Shared/Breadcrumbs/Breadcrumbs";
import { routes } from "./constants/routes";

export const ScheduleBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "SCHEDULE",
		path: routes.SCHEDULE,
	},
];

export const JobBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "JOBS",
		path: routes.JOBS,
	},
];

export const JobCreateBreadcrumbs: BreadcrumbItem[] = [
	...JobBreadcrumbs,
	{
		title: "NEW_JOB",
		path: routes.JOB_CREATE,
	},
];

export const DocumentBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "DOCUMENTS_TITLE",
		path: routes.DOCUMENTS,
	},
];

export const DocumentFileBreadcrumbs: BreadcrumbItem[] = [
	...DocumentBreadcrumbs,
	{
		title: "UPLOAD_FILE_TITLE",
		path: routes.DOCUMENT_UPLOAD,
	},
];

export const DocumentFileEditBreadcrumbs: BreadcrumbItem[] = [
	...DocumentBreadcrumbs,
	{
		title: "EDIT_FILE_TITLE",
		path: routes.DOCUMENT_EDIT,
	},
];

export const DocumentLinkBreadcrumbs: BreadcrumbItem[] = [
	...DocumentBreadcrumbs,
	{
		title: "UPLOAD_LINK_TITLE",
		path: routes.LINK_UPLOAD,
	},
];

export const DocumentLinkEditBreadcrumbs: BreadcrumbItem[] = [
	...DocumentBreadcrumbs,
	{
		title: "UPLOAD_LINK_EDIT_TITLE",
		path: routes.LINK_UPLOAD,
	},
];

export const TimeReportsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "TIME_REPORTS",
		path: routes.TIME_REPORTS_THIS_MONTH,
	},
];

export const ConsultantBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "CONSULTANTS",
		path: routes.CONSULTANTS,
	},
];

export const ConsultantCollectiveAgreementsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "AGREEMENTS",
		path: routes.AGREEMENT,
	},
];

export const CreateConsultantBreadcrumbs: BreadcrumbItem[] = [
	...ConsultantBreadcrumbs,
	{
		title: "NEW_CONSULTANT",
		path: routes.CONSULTANTS_NEW,
	},
];

export const CreateConsultantCollectiveAgreementsBreadcrumbs: BreadcrumbItem[] = [
	...ConsultantCollectiveAgreementsBreadcrumbs,
	{
		title: "NEW_AGREEMENT",
		path: routes.CREATE_AGREEMENT,
	},
];

export const CustomerBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "CUSTOMERS",
		path: routes.CUSTOMERS,
	},
];

export const CustomerCreateBreadcrumbs: BreadcrumbItem[] = [
	...CustomerBreadcrumbs,
	{
		title: "NEW_CUSTOMER",
		path: routes.CUSTOMER_CREATE,
	},
];

export const CorporateGroupBreadcrumbs: BreadcrumbItem[] = [
	...CustomerBreadcrumbs,
	{
		title: "corporateGroup.plural",
		path: routes.CUSTOMER_CORPORATE_GROUPS,
	},
];

export const CustomerUsersListBreadcrumbs: BreadcrumbItem[] = [
	...CustomerBreadcrumbs,
	{
		title: "CUSTOMER_USERS_LIST_TITLE",
		path: routes.CUSTOMER_USERS_LIST,
	},
];

export const RecruitmentBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "RECRUITMENT",
		path: routes.RECRUITMENT,
	},
];

export const CreateRecruitmentBreadcrumbs: BreadcrumbItem[] = [
	...RecruitmentBreadcrumbs,
	{
		title: "NEW_CANDIDATE",
		path: routes.RECRUITMENT_CREATE,
	},
];

export const ContractBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "CONTRACTS",
		path: routes.CONTRACTS,
	},
];

export const ContractCreateBreadcrumbs: BreadcrumbItem[] = [
	...ContractBreadcrumbs,
	{
		title: "NEW_CONTRACT",
		path: routes.CONTRACTS,
	},
];

export const ReportsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "JOB_REPORTS",
		path: routes.JOB_REPORTS,
	},
];

export const ReportsBreadcrumbsDetails: BreadcrumbItem[] = [
	...ReportsBreadcrumbs,
	{
		title: "JOB_REPORT_DETAILS",
		path: routes.JOB_REPORT_DETAILS,
	},
];

export const InternalUsersBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "USERS",
		path: routes.INTERNAL_USERS,
	},
];

export const InternalUsersInviteBreadcrumbs: BreadcrumbItem[] = [
	...InternalUsersBreadcrumbs,
	{
		title: "CREATE_USER",
		path: routes.INTERNAL_USERS_INVITE,
	},
];

export const InvoicesBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "INVOICES",
		path: routes.INVOICES,
	},
];

export const InvoiceBatchesBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "invoice.invoiceBatches",
		path: routes.INVOICE_BATCHES,
	},
];

export const SalaryBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "SALARY_SECTION",
		path: routes.SALARY,
	},
];

export const SalaryBatchNewBreadcrumbs: BreadcrumbItem[] = [
	...SalaryBreadcrumbs,
	{
		title: "NEW_SALARY_BATCH",
		path: routes.SALARY_NEW_BATCH,
	},
];

export const SalaryBatchDetailsBreadcrumbs: BreadcrumbItem[] = [
	...SalaryBreadcrumbs,
	{
		title: "SALARY_BATCH",
		path: routes.SALARY_BATCH_DETAILS,
	},
];

export const CustomersReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.customerReportTitle",
		path: routes.CUSTOMERS_REPORT,
	},
];

export const CustomerContractsReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.customerContactReportTitle",
		path: routes.CUSTOMER_CONTACTS_REPORT,
	},
];

export const ConsultantReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.consultantReportTitle",
		path: routes.CONSULTANTS_REPORT,
	},
];

export const CandidatesReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.candidateReportTitle",
		path: routes.CANDIDATES_REPORT,
	},
];

export const ConsultantWorkedHoursReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.consultantWorkedHoursReportTitle",
		path: routes.CONSULTANTS_WORKED_HOURS_REPORT,
	},
];

export const SoldHoursAndRevenueReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "reports.soldHoursAndRevenueReportTitle",
		path: routes.SOLD_HOURS_AND_REVENUE_REPORT,
	},
];

export const FeedbackReportBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "FEEDBACK_REPORT",
		path: routes.FEEDBACK_REPORT,
	},
];

export const SettingsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "SETTINGS",
		path: routes.SETTINGS,
	},
];

export const NotificationLogsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "NOTIF_LOGS",
		path: routes.NOTIF_LOGS,
	},
];

export const ApiLogsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "API_LOGS",
		path: routes.API_LOGS,
	},
];

export const ResponseTimeStatsLogsBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "RESPONSE_TIME_STATS",
		path: routes.REPSONSE_TIME_STATS,
	},
];

export const InvoiceBreadcrumbs: BreadcrumbItem[] = [
	{
		title: "INVOICES",
		path: routes.INVOICES,
	},
];

export const InvoiceDetailsBreadcrumbs = (invoiceNumber?: string): BreadcrumbItem[] => [
	...InvoicesBreadcrumbs,
	{
		title: String(invoiceNumber || ""),
		path: ".",
	},
];

export const InvoiceBatchCreateBreadcrumbs: BreadcrumbItem[] = [
	...InvoiceBatchesBreadcrumbs,
	{
		title: "invoiceBatch.new",
		path: routes.INVOICE_BATCH_CREATE,
	},
];

export const InvoiceBatchDetailsBreadcrumbs: BreadcrumbItem[] = [
	...InvoiceBatchesBreadcrumbs,
	{
		title: "invoiceBatch.invoiceBatch",
		path: routes.INVOICE_BATCH_DETAILS,
	},
];
